export default {"src":"/_next/static/media/reebelo-dark.2244e74f.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};